export default __webpack_public_path__ + "static/media/bg-enterprise.1dc7d4c9.jpg";